import _ from "lodash";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import classnames from "classnames";
import { useToggle } from "@sportal/cdk";

import { getHelpContent } from "../../../../store/help/help.reducer";
import { Icon } from "../../../../components";
import { useHighlightContext } from "../../HighlightContext/HighlightContext";

import "./NavigationMenu.scss";

const sectionToTab = (section) => ({
  id: section.id,
  text: section.header.text,
});

const getTabs = (sections) =>
  _.transform(
    sections,
    (tabs, section, index) => {
      if (section.level > 1) {
        return;
      }

      const subItems = _.takeWhile(
        sections.slice(index + 1),
        ({ level }) => level > 1
      );
      tabs.push({
        ...sectionToTab(section),
        subItems: _.map(subItems, sectionToTab),
      });
    },
    []
  );

const NavigationMenuItem = ({ id, text, subItems }) => {
  const { activeSection } = useHighlightContext();

  const isActive = activeSection === id;
  const isSubItemActive = _.some(subItems, { id: activeSection });

  const [isOpen, toggleIsOpen] = useToggle(isActive || isSubItemActive);

  useEffect(() => {
    toggleIsOpen(isActive || isSubItemActive);
  }, [toggleIsOpen, isActive, isSubItemActive]);

  const icon = _.isEmpty(subItems)
    ? "fa-regular fa-circle-small"
    : isOpen
    ? "fa-solid fa-caret-down"
    : "fa-solid fa-caret-right";

  return (
    <li>
      <div
        className={classnames("help-page-navigation__list-item", {
          "help-page-navigation__list-item--active":
            isActive || (!isOpen && isSubItemActive),
        })}
      >
        <div
          className="help-page-navigation__icon-wrapper"
          onClick={toggleIsOpen}
        >
          <Icon icon={icon} />
        </div>
        <Link to={`/help/${id}`} className="help-page-navigation__link">
          {text}
        </Link>
      </div>
      {!_.isEmpty(subItems) && isOpen && (
        <ul className="help-page-navigation__sub-menu">
          {_.map(subItems, ({ id, text }) => (
            <li
              key={id}
              className={classnames("help-page-navigation__sub-menu-item", {
                "help-page-navigation__sub-menu-item--active":
                  activeSection && activeSection === id,
              })}
            >
              <Link to={`/help/${id}`} className="help-page-navigation__link">
                {text}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </li>
  );
};

export const NavigationMenu = () => {
  const helpSections = useSelector(getHelpContent);
  const tabs = getTabs(helpSections);

  return (
    <ul className="help-page-navigation__list">
      {_.map(tabs, ({ id, text, subItems }) => (
        <NavigationMenuItem key={id} id={id} text={text} subItems={subItems} />
      ))}
    </ul>
  );
};
